const CVE_ID_PATTERN = /^CVE-\d{4}-\d{4,}$/i;

/**
 * Returns the NVD detail-page URL for a `cve_or_rule` value, or null when
 * the value isn't a CVE ID (e.g. a linter/scanner rule name, or — on the
 * License Compliance page, where this same field is reused for license
 * identifiers — an SPDX license string).
 *
 * Expects `cveOrRule` to already be trimmed. Trimming is the caller's
 * responsibility (see `CveCell`) so that whatever text is displayed is
 * exactly what this function validated and linked — a single owner avoids
 * the two functions silently drifting out of sync.
 */
export function nvdUrl(cveOrRule: string): string | null {
  if (!CVE_ID_PATTERN.test(cveOrRule)) return null;
  return `https://nvd.nist.gov/vuln/detail/${cveOrRule.toUpperCase()}`;
}
